var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#3D8ECD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.432 0 4.314 8.855C28.3 13.363 24.606 22.923 24.19 27.14c8.1 1.533 22.733 8.901 16.465 26.105-6.268 17.204-22.673 14.758-30.091 11.385-5.186-2.262-14.24-12.006-8.97-32.89C6.861 10.856 26.346 1.878 35.431 0ZM86.258 0l4.315 8.855c-11.446 4.508-15.14 14.068-15.557 18.285 8.1 1.533 22.733 8.901 16.465 26.105C85.213 70.449 68.81 68.003 61.39 64.63c-5.186-2.262-14.24-12.006-8.97-32.89C57.687 10.856 77.173 1.878 86.257 0Z"
  }))));
};
export default SvgQuotes;